/** Rank only matching public cards; absent/stale IDs never add a result. */
export function orderByRecommendation<T extends { id: string }>(stories: T[], ids: readonly string[]): T[] {
    const positions = new Map(ids.map((id, index) => [id, index]));
    return [...stories].sort((a, b) => (positions.get(a.id) ?? Infinity) - (positions.get(b.id) ?? Infinity));
}
